export const checkIfIsArray = <T>(value: unknown): value is readonly T[] =>
  Array.isArray(value);
